import { useContext } from 'react';
import { ExploreContextProvider, ExploreContext } from './context';

export const useExploreContext = () => useContext(ExploreContext);

export default ExploreContextProvider;
